import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { authContext } from './AuthContext';
import { UserType } from 'helpers/enums';


interface IApplicationUserContext {
    isLoading: boolean
    isAuthorized: boolean
    currentUser: IUser | undefined
}

interface IUser {
    email: string
    firstName: string
    lastName: string
    countryCode: string
    userType: UserType
    isSuperAdmin: boolean
    canAddDealers: boolean
}

export let appUserContext = React.createContext({} as IApplicationUserContext);

let { Provider } = appUserContext;

let ApplicationUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(true);
    let [isAuthorized, setAuthorize] = useState(false);
    let [currentUser, setCurrentUser] = useState<IUser>();


    useEffect(() => {
        if (authService.isLoading === false && authService.isAuthenticated === true)
            getCurrentUser();
    }, [authService.isLoading, authService.isAuthenticated])


    let getCurrentUser = async () => {
        try {
            setLoading(true);
            let res = await axios.get('/api/User/GetCurrentUser');

            let { item } = res.data;

            setAuthorize(item.isAuthorized);
            setCurrentUser(item);

        } catch (err) {
        } finally {
            setLoading(false);
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                isAuthorized,
                currentUser,
            }}
        >
            {children}
        </Provider>
    )
}

export default ApplicationUserProvider;